import { refundApi } from '../refundApi';
import { SmartEnumType } from '../types/refundTypes';

const lookupEndpoints = refundApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get refund types
    // GET /RefundType
    getRefundTypes: builder.query<SmartEnumType[], void>({
      query: () => 'RefundType',
      providesTags: ['RefundType'],
    }),

    // Get refund priorities
    // GET /RefundPriority
    getRefundPriorities: builder.query<SmartEnumType[], void>({
      query: () => 'RefundPriority',
      providesTags: ['RefundPriority'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRefundTypesQuery, useGetRefundPrioritiesQuery } = lookupEndpoints;
